import { UPDATE_PROFILE } from '../config/url';
import axios from "axios";
import authHeader from './auth-header';

class CompanyService {
  register(company) {
    // console.log(company)
    // Check if company is FormData (for file uploads)
    const isFormData = company instanceof FormData;

    return axios.post(UPDATE_PROFILE, company, {
      headers: {
        ...authHeader(),
        // Let axios set Content-Type automatically for FormData
        ...(isFormData ? {} : { 'Content-Type': 'application/json' })
      }
    }).then((res) => {
      return res;
    }).catch(error => {
      throw new Error(error)
    });
  }
}

export default new CompanyService();